exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._34N37djx5iodsM57hSIfen{position:relative}._34N37djx5iodsM57hSIfen ._3U3WtAKTyuH_4CbNKUhMPI{text-align:center;max-width:500px;margin:0 auto}._34N37djx5iodsM57hSIfen ._1qIQKaCjLDacqSaMhoJtdt{text-align:center;margin:20px 0}\n", ""]);

// Exports
exports.locals = {
	"WahooFlow": "_34N37djx5iodsM57hSIfen",
	"instructions": "_3U3WtAKTyuH_4CbNKUhMPI",
	"centeredImg": "_1qIQKaCjLDacqSaMhoJtdt"
};